<template>
  <div class="public_bg">
    <div class="nurse_top">
      <div style="height:54px;line-height:54px;">
        <img style="vertical-align:middle;" src="@/assets/beadhouse/juxing.png">
          <span>{{serviceManage.serviceCategory}}</span>
      </div>
    </div>
    <div class="row_link clearfix">
      <div class="item" v-for='(item,index) in infoList' :key="index" @click="handleClick(item.uid)">
        <a>
          <img :src="item.img">
          <h5 style="font-size:16px;">{{item.title}}</h5>
          <span>{{item.text}}</span>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import bus from "@/vuex/eventBus"; //引入eventBus,接收子界面传递的跳转指令,然后在父界面跳转,添加tab
export default {
  name:"ServiceManage",  
  data(){
    return {
      serviceManage: {
  serviceCategory: "服务类别",
  title_1: "服务类别管理",
  title_2: "服务人员",
  title_3: "服务工单管理",
  title_4: "服务组管理",
  title_5: "统计报表",
  title_6: "商家评论",
  title_7: "专家管理",
  title_8: "远程监测",
  title_9: "远程看护工单管理",
  text_1: "对服务的项目进行管理",
  text_2: "对服务人员进行管理",
  text_3: "对服务工单进行管理",
  text_4: "对服务组进行管理",
  text_5: "查看订单的信息",
  text_6: "查看对商家的评论"
},//引入 lang 里面的字符串资源
      infoList:[],//数据源
    }
  },
  methods:{
    //点击每个
    handleClick(uid){
      console.log(uid);
      switch(uid){
        case 1:
          bus.$emit('homePage',{type:'jump',path:'/ServiceCategoryNew',title:this.serviceManage.title_1});
          break;
        case 2:
          bus.$emit('homePage',{type:'jump',path:'/ServicePersonnel',title:this.serviceManage.title_2});
          break;
        case 3:
          bus.$emit('homePage',{type:'jump',path:'/ServiceWorkOrder',title:this.serviceManage.title_3});
          break;  
        case 4:
          bus.$emit('homePage',{type:'jump',path:'/ServiceGroup',title:this.serviceManage.title_4});
          break;  
        case 5:
          bus.$emit('homePage',{type:'jump',path:'/ServiceReport',title:this.serviceManage.title_5});
          break; 
        case 6:
          bus.$emit('homePage',{type:'jump',path:'/serviceComment',title:this.serviceManage.title_6});
          break;
        case 7:
          bus.$emit('homePage',{type:'jump',path:'/ServiceSpecial',title:"专家管理"});
          break;     
        case 8:
          bus.$emit('homePage',{type:'jump',path:'/Telemedicine',title:"远程监测"});
          break;  
        case 9:
          bus.$emit('homePage',{type:'jump',path:'/TelemedicineWorkOrder',title:"远程看护工单管理"});
          break; 
      }
    },

    /**
     * 获取菜单栏的数据列表
    */
    getPageData() {

      this.infoList = [
        {
          url:"/ServiceCategory",
          uid:1,
          title:this.serviceManage.title_1,
          text:this.serviceManage.text_1,
          img:require("@/assets/beadhouse/ServiceCategory.png"),
        },
        {
          url:"/ServicePersonnel",
          uid:2,
          title:this.serviceManage.title_2,
          text:this.serviceManage.text_2,
          img:require("@/assets/beadhouse/ServicePersonnel.png"),
        },
        {
          url:"/ServiceWorkOrder",
          uid:3,
          title:this.serviceManage.title_3,
          text:this.serviceManage.text_3,
          img:require("@/assets/beadhouse/ServiceWorkOrder.png"),
        },
        {
          url:"/ServiceGroup",
          uid:4,
          title:this.serviceManage.title_4,
          text:this.serviceManage.text_4,
          img:require("@/assets/beadhouse/volunteerservicelist.png"),
        },
        {
          url:"/ServiceReport",
          uid:5,
          title:this.serviceManage.title_5,
          text:this.serviceManage.text_5,
          img:require("@/assets/beadhouse/EvaluationListleyi.png"),
        },
        {
          url:"/serviceComment",
          uid:6,
          title:this.serviceManage.title_6,
          text:this.serviceManage.text_6,
          img:require("@/assets/beadhouse/volunteergiftsRecord.png"),
        },
        {
          url:"/ServiceSpecial",
          uid:7,
          title:"专家管理",
          text:'查看社区的所有专家',
          img:require("@/assets/beadhouse/ServicePersonnel.png"),
        },
        {
          url:"/TelemedicineWorkOrder",
          uid:8,
          title:"远程看护工单管理",
          text:'远程看护服务工单管理',
          img:require("@/assets/beadhouse/volunteergiftsRecord.png"),
        },
        
      ]
    }
  },
  created(){
    this.getPageData(); 
  },
  mounted(){
        
  },
}
</script>
<style lang="scss" scoped>
  .public_bg {
    min-width: 100%;
    height: 95%;
    padding:0px 0 20px 0;
    background: #FEFEFE;
    .nurse_top {
      border: 1px #F1EFF2 solid;
      background: #F9F7FA;
      position: relative;
        img {
          margin: 14px 12px;
        }
        h5 {
          display: inline-block;
          position: absolute;
          top: 12px;
          font-size: 18px;
        }
    }
    .row_link{
      width: 1259px;
      margin: 34px 35px;
      .item {
        width: 275px;
        height: 99px;
        border: #F0F0F2 1px solid;
        margin-bottom: 34px;
        margin-right: 34px;
        float: left;
        cursor: pointer;
        img {
          float: left;
          margin: 8px 23px 8px 33px;
          margin-right: 16px;
        }
        span {
          color: #666666;
        }
        h5 {
          margin-top: 21px;
          margin-bottom: 8px;
        }
        a:hover {
          color: #333; 
        }
      }
      .item:hover{
        border:1px solid red;
      }
    }
  }
</style>
